import type { Id } from "@convex/_generated/dataModel";

export interface UserProfile {
  _id: Id<"users">;
  username?: string;
  firstName?: string;
  lastName?: string;
  imageUrl?: string;
  lastSignInAt?: number;
  twitchUsername?: string;
  youtubeChannelId?: string;
  youtubeChannelUrl?: string;
  twitterHandle?: string;
  stats: {
    totalLoadouts: number;
    totalTierLists: number;
    totalWeaponBuilds: number;
    joinedAt: number;
  };
}

export function getDisplayName(profile: UserProfile): string {
  return profile.firstName && profile.lastName
    ? `${profile.firstName} ${profile.lastName}`
    : profile.username || "BF6 Player";
}

export function getInitials(name: string): string {
  return name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);
}

export function formatJoinDate(timestamp: number): string {
  return new Date(timestamp).toLocaleDateString("en-US", {
    month: "long",
    year: "numeric",
  });
}
